var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkDifferent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    width: 467,
    height: 30,
    viewBox: "0 0 467 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    display: "block"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#work-different_svg__clip0_0_11)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202.327 5.99h-6.008v17.996h6.008V5.991zM178.272 5.99h18.047V0h-24.055v30h24.055v-6.014h-18.047V5.991zM214.366 0h-6.008v30h6.008V0zM220.374 0v30h6.031V17.995h24.055v-5.99h-24.055V5.99h24.055V0h-30.086zM322.624 5.99V0h-30.062v30H322.624v-6.014H298.57v-5.99h24.054v-5.991H298.57V5.99h24.054zM394.812 5.99V0H364.75v30H394.812v-6.014h-24.055v-5.99h24.055v-5.991h-24.055V5.99h24.055zM436.914 0v5.99h12.039V30h6.008V5.99H467V0h-30.086zM406.851 5.99V0h-6.031V30h6.031V12.005h6.008V5.99h-6.008zM418.867 12.005h-6.008v5.99h6.008v-5.99zM424.898 5.99V17.996h-6.031v5.991h6.031V30h6.008V0h-6.008v5.99zM30.063 0h-6.008v23.986h6.008V0zM12.016 23.986H6.008v5.99h6.008v-5.99zM6.008 0H0v23.986h6.008V0zM18.047 0h-6.008v23.986h6.008V0zM24.055 23.986h-6.008v5.99h6.008v-5.99z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M60.149 0H42.102v5.99h18.047V0zM66.157 5.99h-6.008v17.996h6.008V5.991zM42.102 5.99h-6.008v17.996h6.008V5.991zM60.149 23.986H42.102v5.99h18.047v-5.99z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M96.243 12.005v5.99h6.007V5.991h-6.007v6.014zM78.196 17.995V5.991h18.047V0H72.188v30h6.008v-6.014h18.047v-5.99H78.196zM102.25 23.986h-6.007v5.99h6.007v-5.99z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M138.344 0h-6.007v5.99h6.007V0zM132.313 5.99h-6.008v5.991h6.008v-5.99zM114.29 12.005V0h-6.032v30h6.032V17.995h12.015v-5.99H114.29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.313 17.995h-6.008v5.991h6.008v-5.99zM138.344 23.986h-6.007v5.99h6.007v-5.99z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M256.468 0v30h6.008V17.995h24.078v-5.99h-24.078V5.99h24.078V0h-30.086z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M352.71 12.005v5.99h6.008V5.991h-6.008v6.014z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.663 17.995V5.991h18.047V0h-24.054v30h6.007v-6.014h18.047v-5.99h-18.047z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.718 23.986h-6.008v5.99h6.008v-5.99z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "work-different_svg__clip0_0_11"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h467v30H0z"
  })))));
}
export default SvgWorkDifferent;